export const MAX_FAVORITES_LIMIT = 25;